import {WorkflowDefinitionActionTypeEnum} from 'src/api/ProactApiClient';
import {ActionEmailEditor} from './ActionEmailEditor';
import {ActionCreateTaskEditor} from './ActionCreateTaskEditor';
import {ActionExtendBadgeEditor} from './ActionExtendBadgeEditor';
import type {ActionEditorProps} from './ActionCard';

export interface ActionTypeConfig {
  type: WorkflowDefinitionActionTypeEnum;
  label: string;
  description: string;
  editor: React.FC<ActionEditorProps>;
}

export const actionTypeConfigs: ActionTypeConfig[] = [
  {
    type: WorkflowDefinitionActionTypeEnum.Email,
    label: 'Send Email',
    description: 'Send a notification email to selected recipients.',
    editor: ActionEmailEditor,
  },
  {
    type: WorkflowDefinitionActionTypeEnum.CreateTask,
    label: 'Create Task',
    description:
      'Create an action, approval, toolbox talk, or form task assigned to targeted users.',
    editor: ActionCreateTaskEditor,
  },
  {
    type: WorkflowDefinitionActionTypeEnum.ExtendBadgeExpiration,
    label: 'Extend Badge Expiration',
    description:
      "Extend a contractor's badge expiration date by a specified number of days.",
    editor: ActionExtendBadgeEditor,
  },
];

export const getActionConfig = (
  type: WorkflowDefinitionActionTypeEnum
): ActionTypeConfig | undefined =>
  actionTypeConfigs.find(c => c.type === type);
